import type { DeviceCapability, QualityPreset } from "./sceneTypes";
import { getViewportTier } from "../viewport";

export function getQualityPreset(capability: DeviceCapability): QualityPreset {
  const viewportTier = getViewportTier(capability.viewportWidth);

  if (capability.prefersReducedMotion) {
    return "low";
  }

  if (viewportTier === "mobile" || capability.hardwareConcurrency <= 4 || (capability.deviceMemory ?? 4) <= 4) {
    return "low";
  }

  if (viewportTier === "tablet" || capability.isTouch) {
    return "medium";
  }

  return "high";
}

export function getCanvasDpr(quality: QualityPreset): [number, number] {
  switch (quality) {
    case "high":
      return [1.1, 1.9];
    case "medium":
      return [1, 1.55];
    default:
      return [1, 1.2];
  }
}
